<template>
  <div>

    <cc-collapse :title="$t('ct-sizes')">
      <cc-slider-component ref="widthConfig"></cc-slider-component>
      <cc-slider-component ref="heightConfig"></cc-slider-component>
      <cc-slider-component ref="minHeightConfig"></cc-slider-component>
      <cc-slider-component ref="minWidthTabletConfig"></cc-slider-component>
    </cc-collapse>

    <cc-collapse :title="$t('ct-background-settings')">
      <cc-box-color ref="backgroundColor"></cc-box-color>
      <cc-image-component ref="backgroundImage"></cc-image-component>
    </cc-collapse>

    <cc-collapse :title="$t('ct-border')">
      <cc-border-component ref="border"></cc-border-component>
    </cc-collapse>

    <cc-collapse  :title="$t('ct-border-radius')">
      <cc-border-radius-component ref="borderRadius"></cc-border-radius-component>
    </cc-collapse>

    <cc-collapse  :title="$t('ct-shadow')">
      <cc-shadow ref="shadow"></cc-shadow>
    </cc-collapse>

    <cc-collapse  :title="$t('ct-parallax')">
      <cc-parallax ref="parallax"></cc-parallax>
    </cc-collapse>

    <cc-collapse  :title="$t('ct-animation')">
      <cc-animation ref="animation"></cc-animation>
    </cc-collapse>

    <cc-collapse  :title="$t('ct-padding')" class="padding-mobile">
      <cc-padding ref="padding" ></cc-padding>
    </cc-collapse>

    <cc-collapse  :title="$t('ct-tag')">
      <cc-tag ref="tag"></cc-tag>
    </cc-collapse>


    <cc-collapse  :title="$t('ct-integrations')">

      <div class="form-group">
        <label style="margin-right: 20px" for="">Hotmart Upsell</label> <br>
        <toggle-button-component
            :checked="config.hotmart.enabled"
            @change="enableHotmart"
            color="information"
          />
          <span v-text="$t('ct-enable')" />
      </div>
      <cc-box-color v-show="config.hotmart.enabled" ref="backgroundHotmart"></cc-box-color>

       <div v-show="config.hotmart.enabled" class="form-group">
          <alert-box-component type="warning" :with_icon="true">
          <span
            slot="content"
            v-text="$t('ct-hotmart-help')"
          />
        </alert-box-component>


        <label style="margin-top: 20px" for="">{{ $t('ct-key') }}</label>
        <input  type="text" class="form-control" v-model="config.hotmart.key">

       </div>

       <div class="d-flex flex-column m-3" v-if="config.hotmart.enabled">
          <button class="cheetah-button cheetah-button-color-success cheetah-button-size-large"  @click="saveHotmart()">
              <i class="fa fa-save" />
              {{ $t('ct-save') }}
          </button>
      </div>

     


      <div class="form-group">
        <label style="margin-right: 20px" for="">Eduzz</label> <br>
        <toggle-button-component
            :checked="config.eduzz.enabled"
            @change="enableEduzz"
            color="information"
          />
          <span v-text="$t('ct-enable')" />
      </div>

       <div v-show="config.eduzz.enabled" class="form-group">
          <alert-box-component type="warning" :with_icon="true">
          <span
            slot="content"
            v-text="$t('ct-hotmart-help')"
          />
      </alert-box-component>


        <label style="margin-top: 20px" for="">{{ $t('ct-key') }}</label>
        <input  type="text" class="form-control" v-model="config.eduzz.code">

       </div>

        
      <div class="d-flex flex-column m-3" v-if="config.eduzz.enabled">
          <button class="cheetah-button cheetah-button-color-success cheetah-button-size-large"  @click="saveEduzz()">
              <i class="fa fa-save" />
              {{ $t('ct-save') }}
          </button>
      </div>

    </cc-collapse>

    <cc-collapse  :title="$t('ct-layers')">
      <cc-z-index ref="z-index"></cc-z-index>
    </cc-collapse>

  </div>

</template>

<script>

import AlertBoxComponent from '../../../commons/AlertBoxComponent';
import ToggleButtonComponent from '../../../commons/ToggleButtonComponent';


export default {
  name: 'Options',
  components: {
    AlertBoxComponent,
    ToggleButtonComponent
  },
  data() {
    return {
      config: {
        hotmart: {
           enabled: false,
            key: ''
        },
         eduzz: {
           enabled: false,
            code: ''
        }
      },
      callback: () => {}
    };
  },
  methods: {
    init(config, callback) {
      let vm = this;


      vm.config = _.clone(config);

      

      if(typeof vm.config.hotmart === 'undefined') {
        vm.config.hotmart = {
          enabled: false,
          key: ''
        }
      }

      if(typeof vm.config.eduzz === 'undefined') {
        vm.config.eduzz = {
          enabled: false,
          code: ''
        }
      }


      vm.callback = callback;

      // sizes
      this.$refs['widthConfig'].setValues({defaultValue: vm.config.width, defaultValueChecked: true, min: 50, max: 1400, canBeCheckbox: false, labelDesc: 'width', name: 'iconColor', callback: vm.setWidth});
      this.$refs['heightConfig'].setValues({defaultValue: vm.config.height, defaultValueChecked: true, min: 10, max: 800, canBeCheckbox: false, labelDesc: 'height', name: 'iconColor', callback: vm.setHeight});
      this.$refs['minHeightConfig'].setValues({defaultValue: vm.config.minHeight, defaultValueChecked: true, min: 10, max: 800, canBeCheckbox: false, labelDesc: 'min-height', name: 'iconColor', callback: vm.setMinHeight});
      this.$refs['minWidthTabletConfig'].setValues({defaultValue: vm.config.maxWidth, defaultValueChecked: true, min: 50, max: 800, canBeCheckbox: false, labelDesc: 'max-width-tablet', name: 'iconColor', callback: vm.setMaxWidth});

      // border
      this.$refs['border'].setValues({defaultValue: vm.config.border, labelDesc: 'border', name: 'border', callback: vm.setBorder});
      this.$refs['borderRadius'].setValues({defaultValue: vm.config.borderRadius, labelDesc: 'borderRadius', name: 'borderRadius', callback: vm.setBorderRadius});

      // shadow
      this.$refs['shadow'].setValues({defaultValue: vm.config.boxShadow, labelDesc: 'shadow', name: 'shadow', callback: vm.setShadow});

      // parallax
      this.$refs['parallax'].setValues({parallaxActive: vm.config.parallaxActive, parallaxEffect: vm.config.parallaxEffect, parallaxSpeed: vm.config.parallaxSpeed, element: null, labelDesc: 'parallax', name: 'parallax', callback: vm.setParallax});

      // padding
      this.$refs['padding'].setValues({
        defaultTop: vm.config.paddingTop,
        defaultBottom: vm.config.paddingBottom,
        defaultLeft: vm.config.paddingLeft,
        defaultRight: vm.config.paddingRight,
        min: 0,
        max: 150,
        labelDesc: 'padding',
        callback: vm.setPadding
      });

      // tag
      this.$refs['tag'].setValues({tag: vm.config.tag, callback: vm.setTag});

      // z-index
      this.$refs['z-index'].setValues({defaultValue: vm.config.zIndex, callback: vm.setZIndex});

      // animation
      this.$refs['animation'].setValues({
        action: vm.config.animation.in.action,
        effect: vm.config.animation.in.effect,
        scroll: vm.config.animation.in.scroll,
        time: vm.config.animation.in.time,
        speed: vm.config.animation.in.speed,
        infinite: vm.config.animation.in.infinite,
        labelDesc: 'animate',
        name: 'animate',
        callback: vm.setAnimation
      }, null);

      // background
      this.$refs['backgroundColor'].setValues({defaultValue: vm.config.backgroundColor, gradient: true, labelDesc: 'bg-color', name: 'backgroundColor', callback: vm.setBackgroundColor});
      this.$refs['backgroundImage'].setValues({
        defaultValue: vm.config.backgroundImage,
        defaultValueOrigin: vm.config.backgroundOrigin,
        defaultValueRepeat: vm.config.backgroundRepeat,
        defaultValueSize: vm.config.backgroundSize,
        defaultValueAttachment: vm.config.backgroundAttachment,
        defaultValuePosition: vm.config.backgroundPosition,
        canExternal: true,
        canRemove: true,
        callback: vm.setBackgroundImage
      });

      this.$refs['backgroundHotmart'].setValues({defaultValue: vm.config.hotmart.background, gradient: true, labelDesc: 'bg-color', name: 'backgroundColor', callback: vm.setBackgroundColorHotmart});

    },
    setPadding(data) {
      this.config.paddingTop = `${data.paddingTop}px`;
      this.config.paddingBottom = `${data.paddingBottom}px`;
      this.config.paddingLeft = `${data.paddingLeft}px`;
      this.config.paddingRight = `${data.paddingRight}px`;
      this.save();
    },
    setZIndex(value) {
      this.config.zIndex = value;
      this.save();
    },
    setTag(value) {
      this.config.tag = value;
      this.save();
    },
    setAnimation(data) {
      this.config.animation.in = _.merge(this.config.animation.in, data);
      this.save();
    },
    setParallax(data) {
      this.config = _.merge(this.config, data);
      this.save();
    },
    setBorder(data) {
      this.config.border = `${data.size}px ${data.style} ${data.color}`;
      this.save();
    },
    setBorderRadius(data) {
      this.config.borderRadius = data.value;
      this.save();
    },
    setWidth(value) {
      this.config.width = `${value}px`;
      this.save();
    },
    setMaxWidth(value) {
      this.config.maxWidth = `${value}px`;
      this.save();
    },
    setHeight(value) {
      this.config.height = `${value}px`;
      this.save();
    },
    setMinHeight(value) {
      this.config.minHeight = `${value}px`;
      this.save();
    },
    setBackgroundColor(value) {
      this.config.backgroundColor = value;
      this.save();
    },
    setBackgroundColorHotmart(value) {
      this.config.hotmart.background = value;
      this.save();
    },
    setShadow(data) {
      this.config.boxShadow = `${data.h}px ${data.v}px ${data.b}px ${data.s}px ${data.color}  ${data.inset ? 'inset' : ''}`;
      this.save();
    },
    setBackgroundImage(data) {
      if (data.type === 'setImage') {
        this.config.backgroundColor = 'white';
        this.config.backgroundImage = data.src;
      }

      if (data.type === 'removeImage') {
        this.config.backgroundImage = 'none';
      }

      if (data.type === 'setConfig') {
        this.config.backgroundColor = 'white';
        this.config.backgroundPosition = data.position;
        this.config.backgroundSize = data.size;
        this.config.backgroundRepeat = data.repeat;
        this.config.backgroundOrigin = data.origin;
        this.config.backgroundAttachment = data.attachment;
      }

      this.save();
    },
    enableHotmart(value) {
     if(value) { this.config.eduzz.enabled = !value; }
      this.config.hotmart.enabled = value;
      this.save()
    },
    enableEduzz(value) {
      if(value) { this.config.hotmart.enabled = !value; }
      this.config.eduzz.enabled = value;
      this.save()
    },
    saveHotmart() {
       this.config.hotmart.key =  this.config.hotmart.key.replaceAll("'", "")
      this.$snotify.success(
        this.$t('ct-saved-successfully')
      );
      this.save();
    },
    saveEduzz() {
       this.config.eduzz.code =  this.config.eduzz.code.replaceAll("'", "")
      this.$snotify.success(
        this.$t('ct-saved-successfully')
      );
      this.save();
    },
    save() {
      this.callback(this.config);
    }
  },
  beforeDestroy() {
    this.config = {};
    this.callback = () => {};
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Box/Options.vue